import { FC } from 'react';

import { IconFormer } from '@shared/components/IconsFormer';
import { FallbackProps } from 'react-error-boundary';

/**
 * gift-store 결제/조회 플로우용 사용자 친화 에러 폴백.
 * 렌더 단계 예외로 화면이 백지가 되는 것을 막고, 고객센터 전화 연결을 안내한다.
 */
export const GiftErrorFallback: FC<FallbackProps> = function GiftErrorFallback({
  error,
  resetErrorBoundary,
}) {
  return (
    <div
      role="alert"
      className="center-box min-h-[60vh] flex-col gap-5 px-6 text-center"
    >
      <div className="text-5xl">⚠️</div>
      <div className="space-y-1">
        <p className="text-lg font-bold">일시적인 오류가 발생했습니다</p>
        <p className="break-keep text-sm text-gray-500">
          잠시 후 다시 시도해 주세요. 문제가 계속되면 아래 고객센터로 연락 주시면
          도와드리겠습니다.
        </p>
      </div>

      {/* 에러 사유 — 간단 표시 (상담 시 참고용) */}
      {error?.message && (
        <p className="max-w-full break-all rounded-md bg-gray-100 px-3 py-2 text-xs text-gray-400">
          {error.message}
        </p>
      )}

      <a href="tel:15771954" className="block">
        <div className="center-box gap-2 text-[21px] font-bold">
          <IconFormer.Phone className="wh-5 fill-gray-700" />
          <p>1577-1954</p>
        </div>
        <p className="break-keep text-xs text-gray-400">
          클릭시 상담원에게 바로 연결됩니다
        </p>
      </a>

      <button
        type="button"
        onClick={resetErrorBoundary}
        className="mt-1 rounded-lg bg-red-500 px-6 py-2.5 text-base font-bold text-white active:bg-red-600"
      >
        다시 시도
      </button>
    </div>
  );
};
